module.exports = __webpack_public_path__ + "static/media/1001210TL.4a962a83.jpg";